const MAX_RETRIES = 10;
const RETRY_DELAY = 1000;

module.exports = {
    MAX_RETRIES,
    RETRY_DELAY,
};
